import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import { useLanguage } from './LanguageContext';

export default function LanguageSync() {
  const { user } = useAuth();
  const { language } = useLanguage();
  const userId = user?.id;
  const isDemo = user?.is_demo;
  useEffect(() => {
    if (!userId || isDemo) return;
    const controller = new AbortController();
    api.put('/language/', { language }, { signal: controller.signal }).catch(() => {
      // Local browsing remains available if the notification preference cannot sync.
    });
    return () => controller.abort();
  }, [userId, isDemo, language]);
  return null;
}
